import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import CountrySave from "./CountrySave";


const CountryEdit = () => {

    const {id} = useParams();
    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => {if(!result) {setUser({}); navigate("/Login");}});

    const [country, setCountry] = useState({});

    let response44 = useInvoke("WebApps", "44", {"@CountryID": id});

    useEffect(() => {

        //get country
        if (response44.data.payload != undefined) {
            let data = JSON.parse(response44.data.payload).data[0];

            setCountry(
                {
                    CountryId: data[0],
                    CountryName: data[1],
                    CountryAbbr: data[2],
                    CreatedDate: data[3]
                }
            );
        }

    }, [response44.isPending]);

    const handleFormSubmit = (e) => {

        let countryid = id;
        
        let valid = true;

        let countryname = "";        
        if (document.getElementById("country").value != "") {
            countryname = document.getElementById("country").value;
        }
        else {
            countryname = document.getElementById("country").defaultValue;
        }

        let countryabbr = "";
        if (document.getElementById("abbr").value != "") {
            countryabbr = document.getElementById("abbr").value;
        }
        else {
            countryabbr = document.getElementById("abbr").defaultValue;
        }

        let modifiedbyid = user["id"];
        let deleted = "0";
        
        if (valid) { 
            CountrySave(countryid, countryname, countryabbr, modifiedbyid, deleted);
            toast.success('Success');
            navigate("/Country");
        }
    };

    document.title = "Countries - Edit";
    return ( 
        <div className="countryEdit">
            {user["email"] != undefined &&
                <>
                    {country && 
                    <div className="container body-content" style={{marginTop: "25px"}}>
                            
                        <h2>Edit Country</h2>

                        <form id="countryForm" noValidate="novalidate" autoComplete="off">  

                            <div className="form-group">
                                <label htmlFor="country">Country</label>
                                <input className="form-control" id="country" name="country" type="text" placeholder={country["CountryName"]} autocomplete="off" />
                            </div>

                            <div className="form-group">
                                <label htmlFor="abbr">Abbr</label>
                                <input className="form-control" id="abbr" name="abbr" type="text" placeholder={country["CountryAbbr"]} autocomplete="off" />
                            </div>
        
                        </form> 
                        <Link to="/Country" className="btn btn-default" style={{marginRight: "4px"}}>Cancel</Link>                           
                        <button onClick={handleFormSubmit} className="btn btn-primary" style={{marginRight: "4px"}}>Save</button>                        
                    </div>}
                </>
            }
        </div>
     );
}
 
export default CountryEdit;